(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelOf(details) {
    return details.querySelector('.product-faq__panel');
  }

  function onTransitionEnd(panel, callback) {
    var done = false;
    var timer = window.setTimeout(finish, 400);

    function finish(event) {
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'grid-template-rows' && event.propertyName !== 'opacity') {
        return;
      }
      if (done) return;
      done = true;
      window.clearTimeout(timer);
      panel.removeEventListener('transitionend', finish);
      callback();
    }

    panel.addEventListener('transitionend', finish);
  }

  function expand(details) {
    var panel = panelOf(details);
    if (!panel || reduceMotion) {
      details.open = true;
      return;
    }

    // Keep the panel at 0fr while opening, then drop the class so it animates to 1fr.
    // Adding is-collapsing after open would animate closed first (see collapse, which does the reverse).
    panel.classList.add('is-collapsing');
    details.open = true;
    panel.getBoundingClientRect();
    window.requestAnimationFrame(function () {
      panel.classList.remove('is-collapsing');
    });
  }

  function collapse(details) {
    var panel = panelOf(details);
    if (!panel || reduceMotion) {
      details.open = false;
      return;
    }

    panel.classList.add('is-collapsing');
    onTransitionEnd(panel, function () {
      details.open = false;
      panel.classList.remove('is-collapsing');
    });
  }

  document.querySelectorAll('[data-product-faq]').forEach(function (root) {
    root.querySelectorAll('details').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.open) {
          collapse(details);
        } else {
          expand(details);
        }
      });
    });

    var button = root.querySelector('[data-product-faq-more]');
    if (!button) return;

    button.addEventListener('click', function () {
      root.querySelectorAll('.product-faq__item--hidden').forEach(function (item) {
        item.classList.remove('product-faq__item--hidden');
      });
      button.hidden = true;
      button.classList.add('product-faq__more--hidden');
      button.setAttribute('aria-hidden', 'true');
    });
  });
})();
